module.exports = __webpack_public_path__ + "fonts/opensans-light.f0862da7.ttf";